import { ArticleType } from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';

import { useArticleTypes } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useArticleTypes';
import { useCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCart';
import { usePaymentMethods } from '@/components/modules/Application/components/PaymentMethod/_shared/hooks/usePaymentMethods';

export const useCartAlerts = () => {
  const { cart, cartIsValid } = useCart();
  const { requiredArticleTypes, missingRequiredArticleTypes, needsRequiredArticle } = useArticleTypes();
  const { arePaymentMethodsAvailable } = usePaymentMethods();

  const isNewCart = cart?.items[0]?.data.price === undefined;

  const showTotalAlert = useMemo(() => !isNewCart && !cart?.validTotal(), [cart, isNewCart]);
  const showIncompleteAlert = useMemo(() => !isNewCart && !cart?.itemsAreCompleted(), [cart, isNewCart]);
  const showArticleCategoryAlert = useMemo(() => !isNewCart && !cart?.validArticleCategories(), [cart, isNewCart]);
  const showArticleTypeAlert = useMemo(() => !isNewCart && !cart?.validArticleTypes(), [cart, isNewCart]);

  const showCartItemErrorAlert = useMemo(
    () =>
      !isNewCart &&
      !showTotalAlert &&
      !showIncompleteAlert &&
      !showArticleCategoryAlert &&
      !showArticleTypeAlert &&
      !cartIsValid,
    [cart, cartIsValid, isNewCart],
  );

  return {
    showTotalAlert,
    showIncompleteAlert,
    showArticleCategoryAlert,
    showArticleTypeAlert,
    showCartItemErrorAlert,
    hasService: requiredArticleTypes.includes(ArticleType.SERVICE),
    hasAuto: requiredArticleTypes.includes(ArticleType.AUTOMOBILE),
    needsRequiredArticle: needsRequiredArticle,
    missingTypes: missingRequiredArticleTypes,
    availablePaymentMethods: cart && arePaymentMethodsAvailable(cart.total()),
  };
};
